import { api, ReactQueryOptions, RouterInputs, RouterOutputs } from '@api'
import { UseTRPCInfiniteQueryOptions } from '@trpc/react-query/shared'
import { TRPCClientErrorLike } from '@trpc/client'
import { useSession } from 'next-auth/react'

type inputType = RouterInputs['ArtistManager']['getArtistDrops']
type queryOptionsType = ReactQueryOptions['ArtistManager']['getArtistDrops']
type outputType = RouterOutputs['ArtistManager']['getArtistDrops']
type optionsType = UseTRPCInfiniteQueryOptions<'ArtistManager.getArtistDrops', inputType, outputType, TRPCClientErrorLike<any>>

export const useGetArtistDropsInfiniteList = (input: inputType, options?: optionsType) => {
    const { status } = useSession()
    const { enabled } = options ?? {}

    return api.ArtistManager.getArtistDrops.useInfiniteQuery(input, {
        ...options,
        queryKey: ['ArtistManager.getArtistDrops', input],
        getNextPageParam: (firstPage) => firstPage.nextCursor,
        refetchOnWindowFocus: false,
        initialCursor: undefined,
        staleTime: 15 * 60 * 1000, // 15 mins
        enabled: status === 'authenticated' && enabled,
    })
}

export const useGetArtistDropsList = (input: inputType, options?: queryOptionsType) => {
    const { status } = useSession()
    const { enabled } = options ?? {}

    return api.ArtistManager.getArtistDrops.useQuery(input, {
        ...options,
        queryKey: ['ArtistManager.getArtistDrops', input],
        staleTime: 15 * 60 * 1000, // 15 mins
        enabled: status === 'authenticated' && enabled,
    })
}
